import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { ILead } from "../../models/BaseModel";
import { Fetch, } from "../../shared/Fetch";
import { format } from "date-fns";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Tag } from "primereact/tag";

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

interface ILeadHistory {
    id: number,
    leadId: number,
    statusId: number,
    statusName: string,
    isLeadActive: boolean,
    updatedBy: string,
    comment: string,
    createdAt: number
}

export const LeadHistory = (props: Iprops) => {

    const [tableData, setTableData] = useState({ data: [], loading: false } as { data: ILeadHistory[], loading: boolean });

    useEffect(() => {
        if (props.singleData.id && props.open) loadTableData();
    }, [props.singleData.id, props.open]);

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`leads/getLeadStatusUpdateHistory/${props.singleData.id}`, "GET", null, null, props.toast);
        if (response) {
            const data: { leadHistory: ILeadHistory[] } = await response.json();
            setTableData({ data: data.leadHistory, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    return (
        <Dialog visible={props.open} style={{ width: '60vw' }} header={`Lead Status History (${props.singleData.contactName} | ${props.singleData.contactContact})`} modal className="p-fluid" onHide={props.hideDialog}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" stripedRows scrollHeight="50vh"
                value={tableData.data}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />

                <Column field="statusName" header="Status" body={(rowData) => <Tag severity={rowData.isLeadActive ? 'success' : 'danger'} value={rowData.statusName} rounded></Tag>} sortable></Column>
                <Column field="comment" header="Comment" sortable></Column>
                <Column field="updated_By" header="Updated By" sortable></Column>
                <Column field="createdAt" header="Updated At" body={(rowData) => format(new Date(rowData.createdAt+"Z"), 'dd/MM/yyyy')} sortable></Column>
                <Column field="followup_Date" header="Follow Up Date" body={(rowData) => { if (rowData.followup_Date === null) return ''; else return format(new Date(rowData.followup_Date), 'dd/MM/yyyy') }} sortable></Column>
            </DataTable>
            <ConfirmDialog />
        </Dialog>
    );
}
